import { motion } from "framer-motion";
import Navbar from "../components/Navbar";
import ServiceMenu from "../components/ServiceMenu";
import Footer from "../components/Footer";
import Flourish from "../components/Flourish";

export default function MenuPage() {
  return (
    <div data-testid="menu-page" className="bg-ink">
      <Navbar />

      {/* Menu hero band */}
      <section className="relative pt-40 pb-16 md:pt-48 md:pb-20 overflow-hidden border-b border-gold-primary/10">
        <Flourish className="absolute top-28 left-2 md:left-8 w-28 md:w-48 opacity-70" />
        <Flourish className="absolute bottom-0 right-2 md:right-8 w-28 md:w-48 opacity-70" flip />
        <div className="relative z-10 mx-auto max-w-6xl px-6 md:px-10 text-center">
          <motion.img
            src="/bq-logo.png"
            alt="BQ Nails & Spa"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
            className="mx-auto h-40 md:h-56 w-auto object-contain mb-6"
            data-testid="menu-hero-logo"
          />
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.1 }}
            className="font-body text-xs tracking-[0.4em] uppercase text-gold-muted mb-6"
          >
            Goodyear, Arizona
          </motion.p>
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.15, ease: [0.16, 1, 0.3, 1] }}
            className="font-accent italic gold-gradient-text text-6xl sm:text-7xl md:text-8xl leading-[0.9]"
          >
            Service Menu
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.25 }}
            className="mt-8 mx-auto max-w-xl font-body text-sm md:text-base leading-relaxed text-foreground/50"
          >
            Prices marked with &ldquo;+&rdquo; may vary based on length, design
            and detailing. We are happy to quote your look on arrival.
          </motion.p>
        </div>
      </section>

      <ServiceMenu showHeader={false} />
      <Footer />
    </div>
  );
}
